export const GrossProfitLabelTextHelper = {
    getLabelText: {
        dateOrderOn: 'Order Date',
        orderNumber: 'Order Number',
        marketplaceCode: 'Marketplace Code',
        orderAmountBaseCurrency: 'Order Amount HKD',
        commissionPercentage: 'Commission Percentage',
        commissionAmountBaseCurrency: 'Commission HKD',
        transactionFeeBaseCurrency: 'Transaction Fee HKD',
        productCostAmountTotalBaseCurrency: 'Product Cost HKD',
        orderItemPriceAmountTotalBaseCurrency: 'Item Price Total HKD',
        shippingFeeAmountBaseCurrency: 'Shipping Fee HKD',
        grossProfitAmountBaseCurrency: 'Gross Profit HKD',
        baseCurrencyCode: 'Base Currency',
        foreignCurrencyCode: 'Foreign Currency',
        exchangeRateBaseCurrencyToForeignCurrency: 'HKD to Foreign',
        exchangeRateForeignCurrencyToBaseCurrency: 'Foreign to HKD',
        dateCalculationAt: 'Calculation Date',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        dateOrderOnFrom: 'Order Date From',
        dateOrderOnTo: 'Order Date To',
        orderItemSkuList: 'Item SKU',
        action: 'Action'
    }
};
